export const octopusSyncContent = {
  hero: {
    title: "OctopusSync",
    subtitle: "Multi-Venue Copy Trading and Trade Synchronisation - Built for Retail Speed and Institutional Connectivity",
    description: "OctopusSync is an institutional-grade trade synchronisation platform that ensures consistent, low-latency execution across multiple brokers and infrastructures.",
   },

  about: {
    title: "ABOUT",
    content: [
      "OctopusSync is a cross-platform copy trading and trade synchronisation platform designed to replicate orders and strategies across heterogeneous broker technologies with institutional-grade consistency. It connects retail trading environments (MT4/MT5) with professional and institutional venues and infrastructures, including Interactive Brokers, CQG, Integral and prime-broker connectivity such as Finalto, enabling unified execution logic across multiple accounts, brokers and technology stacks.",
      "At its core, OctopusSync was built to go beyond \"traditional copy trading\" by prioritising the three dimensions that typically break at scale: consistency, latency, and auditability. Through direct FIX connectivity (including FIX 4.4), the platform is architected to support professional-grade order replication, strategy mirroring and operational reliability across venues.",
      "The result is a single operational layer that can synchronise execution and risk posture across distributed accounts, supporting professional workflows where transparency, control and robustness matter as much as performance.",
    ],
  },

  features: {
    title: "FEATURES",
    intro: "Built for cross-technology consistency, low-latency synchronisation, and institutional-grade oversight.",
    items: [
      {
        title: "1) True Cross-Technology Copy Trading",
        description:
          "Replicate trading activity between MT4, MT5 and institutional-grade environments (e.g., IBKR, CQG, Integral), enabling a unified execution framework even when brokers run fundamentally different infrastructures.",
      },
      {
        title: "2) FIX 4.4 Institutional Connectivity",
        description:
          "Designed to support direct integration via FIX 4.4, enabling professional-grade synchronisation and compatibility with prime brokers, banks and institutional platforms where FIX remains the standard for electronic trading workflows.",
      },
      {
        title: "3) Multi-Account Replication with Consistency Controls",
        description:
          "Built for replicating orders across multiple accounts while preserving execution integrity, minimising drift, mismatches and state inconsistencies that typically arise in distributed copy-trading setups.",
      },
      {
        title: "4) Low-Latency, Real-Time Synchronisation",
        description:
          "Engineered for fast replication and rapid reaction to market events, supporting time-sensitive strategies and reducing the impact of manual intervention and operational delays.",
      },
      {
        title: "5) Robust Execution & Routing Compatibility",
        description:
          "Supports integration pathways aligned with venue-grade routing and execution models (including FIX-based connectivity), enabling scale across multi-venue trading operations. CQG, for example, provides FIX connectivity for trade routing and risk workflows.",
      },
      {
        title: "6) Operational Transparency and Auditability",
        description:
          "Designed to support professional monitoring and control requirements, helping teams reconcile trade states, trace actions and validate synchronisation behaviour across brokers and accounts (critical for multi-venue and multi-account environments).",
      },
      {
        title: "7) Institutional-Ready Prime Broker Ecosystem Compatibility",
        description:
          "Supports integration with prime-broker ecosystems (e.g., Finalto) that provide liquidity, execution and prime brokerage solutions across asset classes, facilitating operations that require professional-grade infrastructure and connectivity.",
      },
      {
        title: "8) Scalable Architecture for Growth",
        description:
          "Built to scale from a small set of accounts to larger multi-account operations without compromise synchronisation consistency and operational reliability.",
      },
    ],
  },
};